import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { fetchGet, PATHNAME, schema } from '../api/core-user';
import { withManageConfig } from './utils';

// Same rationale as in use-booked-tickets: prefer the logged-in user's
// manage token from redux over the env-level token from localStorage, which
// is only populated by the OCA login flow.
const selectManageUserToken = (state) => state?.user?.login_info?.manage_api_user?.token;

export const useCoreUser = (params) => {
  const manageUserToken = useSelector(selectManageUserToken);
  const merged = withManageConfig(params);
  const withUserToken = manageUserToken
    ? { ...merged, envJWTToken: manageUserToken }
    : merged;
  const key = schema.safeParse(withUserToken).success ? { PATHNAME, ...withUserToken } : null;
  const swr = useSWR(key, fetchGet(withUserToken), {
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });
  // See use-booked-tickets for rationale. `isReady` is true once the request
  // resolves (data or error), or when there is no manage user token at all
  // (we won't fetch). We deliberately do NOT short-circuit on `key === null`
  // because the key is transiently null on the first render while
  // mAnage.config hydrates.
  const isReady = !manageUserToken || swr.data !== undefined || !!swr.error;
  return { ...swr, isReady };
};
